<template>
  <v-content>
    <v-container fluid>
      <v-card class="elevation-5">
        <v-toolbar dense dark color="deep-orange" elevation="2">
          <v-toolbar-title>Reporte: Avance por Usuario</v-toolbar-title>
          <v-spacer></v-spacer>
          <download-csv v-show="false" ref="export" :data="export_data" name="reporte_avance_usuario.csv"></download-csv>
          <v-btn text small :disabled="!export_data.length || loading" @click="exportData()">
            Exportar
            <v-icon right>mdi-arrow-down</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-title>
          <v-btn small :loading="loading" elevation="0" color="deep-orange" outlined class="mx-2" @click="refresh()">
            Actualizar
            <v-icon right>mdi-refresh</v-icon>
          </v-btn>
          <v-btn small :loading="loading" elevation="0" color="deep-orange" outlined class="mx-2" @click="dialogFilters = true">
            Filtros
            <v-icon right>mdi-filter</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar" class="mx-2" single-line hide-details maxlength="150"></v-text-field>
        </v-card-title>
        <v-data-table :headers="headers" :items="items" :loading="loading" :search="search" fixed-header height="550px"
        :footer-props="{ 'items-per-page-text': 'Elementos por página' }" :items-per-page="-1" item-key="id" class="elevation-1">
          <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
          <template v-slot:footer.page-text="props">
            Página {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
          </template>
          <template v-slot:no-data>
            No hay información disponible
          </template>
          <template v-slot:no-results>
            No se obtuvieron resultados
          </template>
        </v-data-table>
      </v-card>
      <v-dialog v-model="dialogFilters" persistent max-width="600px">
        <v-card>
          <v-toolbar dense dark color="primary" elevation="2">
            <v-toolbar-title>Filtros</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn text small :disabled="loading" @click="clearFilters()">
              Reiniciar
              <v-icon right>mdi-minus</v-icon>
            </v-btn>
            <v-btn text small :disabled="loading" @click="closeFilters()">
              Cerrar
              <v-icon right>mdi-close</v-icon>
            </v-btn>
            <v-btn text small :loading="loading" @click="setFilters()">
              Aceptar
              <v-icon right>mdi-check</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-autocomplete v-model="filters.empresa" :items="empresas" item-value="id" item-text="nombre" label="Empresa" :disabled="loading"></v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete v-model="filters.tipo_servicio" :items="tipos_servicios" multiple item-value="id" item-text="nombre" label="Tipo de servicio" :disabled="loading"></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-dialog ref="startDate" v-model="dialogStartDate" :return-value.sync="filters.fecha_inicio" persistent width="290px">
                    <template v-slot:activator="{ on }">
                      <v-text-field v-model="filters.fecha_inicio" label="Fecha inicio" :disabled="loading" readonly v-on="on"></v-text-field>
                    </template>
                    <v-date-picker v-model="filters.fecha_inicio" locale="es" scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="dialogStartDate = false">Cancelar</v-btn>
                      <v-btn text color="primary" @click="$refs.startDate.save(filters.fecha_inicio)">Aceptar</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-dialog ref="endDate" v-model="dialogEndDate" :return-value.sync="filters.fecha_fin" persistent width="290px">
                    <template v-slot:activator="{ on }">
                      <v-text-field v-model="filters.fecha_fin" label="Fecha fin" :disabled="loading" readonly v-on="on"></v-text-field>
                    </template>
                    <v-date-picker v-model="filters.fecha_fin" locale="es" scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="dialogEndDate = false">Cancelar</v-btn>
                      <v-btn text color="primary" @click="$refs.endDate.save(filters.fecha_fin)">Aceptar</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-snackbar v-model="error" color="error" :timeout="2500" bottom right>
        {{ msgError }}
      </v-snackbar>
      <v-snackbar v-model="success" color="success" :timeout="2500" bottom right>
        {{ msgSuccess }}
      </v-snackbar>
    </v-container>
  </v-content>
</template>

<script>
import Vue from 'vue'
import services from '@/utils/services'
import moment from 'moment'
import jsoncsv from 'vue-json-csv'

Vue.component('download-csv', jsoncsv)

export default {
  name: 'avanceusuario',
  data: () => ({
    loading: false,
    error: false,
    msgError: '',
    success: false,
    msgSuccess: '',
    search: '',
    headers: [],
    headers_default: [
      { text: 'Usuario', align: 'center', sortable: false, width: '100%', value: 'usuario' },
      { text: 'No. Tiendas', align: 'center', sortable: false, width: '100%', value: 'no_tiendas' },
      { text: 'No. Actividades', align: 'center', sortable: false, width: '100%', value: 'no_actividades' }
    ],
    items: [],
    empresas: [],
    tipos_servicios: [],
    export_data: [],
    filters: {
      empresa: '',
      fecha_inicio: '',
      fecha_fin: '',
      tipo_servicio: []
    },
    dialogFilters: false,
    dialogStartDate: false,
    dialogEndDate: false
  }),
  mounted() {
    this.refresh()
    this.dialogFilters = true
  },
  methods: {
    refresh() {
      this.loading = true
      let data = {
        filtros: JSON.stringify(this.filters)
      }
      services.ws('get', 'avanceUsuario', data)
        .then(res => {
          if (res.ok) {
            this.actividades = res.data.actividades
            this.empresas = res.data.empresas
            this.tipos_servicios = res.data.tipos_servicios
            this.prepareHeaders()
            this.prepareExportData()
          }
          else {
            this.error = true
            this.msgError = res.message
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    clearFilters() {
      for (let key in this.filters) {
        if (!Array.isArray(this.filters[key])) {
          this.filters[key] = ''
        }
        else {
          this.filters[key] = []
        }
      }
    },
    closeFilters() {
      this.dialogFilters = false
    },
    setFilters() {
      if (this.filters.empresa !== '') {
        if (this.filters.fecha_inicio === '' || this.filters.fecha_fin === '') {
          this.error = true
          this.msgError = 'Debe establecer el filtro de fechas'
        }
        else if (moment(this.filters.fecha_fin, 'YYYY-MM-DD').diff(moment(this.filters.fecha_inicio, 'YYYY-MM-DD')) < 0) {
          this.error = true
          this.msgError = 'La fecha fin debe ser mayor o igual que la fecha inicio'
        }
        else {
          this.loading = true
          let data = {
            filtros: JSON.stringify(this.filters)
          }
          services.ws('get', 'avanceUsuario', data)
            .then(res => {
              if (res.ok) {
                this.actividades = res.data.actividades
                this.empresas = res.data.empresas
                this.tipos_servicios = res.data.tipos_servicios
                this.prepareHeaders()
                this.prepareExportData()
                this.closeFilters()
              }
              else {
                this.error = true
                this.msgError = res.message
              }
            })
            .finally(() => {
              this.loading = false
            })
        }
      }
      else {
        this.error = true
        this.msgError = 'Debe establecer el filtro de empresa'
      }
    },
    prepareHeaders() {
      this.headers = this.headers_default.slice()
      let usuarios = {}
      let tipos_servicios = {}
      for (let i = 0; i < this.actividades.length; i++) {
        let idusuario = this.actividades[i].idusuario
        let idtienda = this.actividades[i].idtienda
        let idactividad = this.actividades[i].idactividad
        let idtipo_servicio = this.actividades[i].idtipo_servicio
        if (!(idusuario in usuarios)) {
          usuarios[idusuario] = {
            nombre: this.actividades[i].usuario,
            tiendas: {},
            actividades: {},
            tipos_servicios: {}
          }
        }
        if (!(idtienda in usuarios[idusuario].tiendas)) {
          usuarios[idusuario].tiendas[idtienda] = {
            nombre: this.actividades[i].tienda
          }
        }
        if (!(idactividad in usuarios[idusuario].actividades)) {
          usuarios[idusuario].actividades[idactividad] = {
            nombre: this.actividades[i].actividad,
            tipos_servicios: {},
            completado: this.actividades[i].completado
          }
        }
        if (!(idtipo_servicio in usuarios[idusuario].tipos_servicios)) {
          usuarios[idusuario].tipos_servicios[idtipo_servicio] = {
            nombre: this.actividades[i].tipo_servicio,
            actividades: {}
          }
        }
        usuarios[idusuario].tipos_servicios[idtipo_servicio].actividades[idactividad] = {
          nombre: this.actividades[i].actividad,
          completado: this.actividades[i].completado
        }
        if (!(idtipo_servicio in tipos_servicios)) {
          tipos_servicios[idtipo_servicio] = this.actividades[i].tipo_servicio
          let col = {
            text: this.actividades[i].tipo_servicio.toUpperCase(),
            align: 'center',
            sortable: false,
            width: '100%',
            value: 'tipo_servicio_' + idtipo_servicio
          }
          this.headers.push(col)
        }
      }
      for (let key in tipos_servicios) {
        let col = {
          text: '% ' + tipos_servicios[key].toUpperCase(),
          align: 'center',
          sortable: false,
          width: '100%',
          value: 'por_tipo_servicio_' + key
        }
        this.headers.push(col)
      }
      this.items = []
      for (let key in usuarios) {
        let row = {
          usuario: usuarios[key].nombre,
          no_tiendas: Object.keys(usuarios[key].tiendas).length,
          no_actividades: Object.keys(usuarios[key].actividades).length
        }
        for (let key2 in tipos_servicios) {
          if (key2 in usuarios[key].tipos_servicios) {
            let sum = Object.keys(usuarios[key].tipos_servicios[key2].actividades).length
            let count = 0
            for (let key3 in usuarios[key].tipos_servicios[key2].actividades) {
              if (usuarios[key].tipos_servicios[key2].actividades[key3].completado) {
                count += 1
              }
            }
            let por = (sum) ? parseFloat(count / sum * 100).toFixed(2) : 0
            row['tipo_servicio_' + key2] = sum
            row['por_tipo_servicio_' + key2] = por + '%'
          }
          else {
            row['tipo_servicio_' + key2] = 0
            row['por_tipo_servicio_' + key2] = 0.00 + '%'
          }
        }
        this.items.push(row)
      }
    },
    prepareExportData() {
      this.export_data = []
      for (let i = 0; i < this.items.length; i++) {
        let row = {}
        for (let j = 0; j < this.headers.length; j++) {
          row[this.headers[j].text] = this.items[i][this.headers[j].value]
        }
        this.export_data.push(row)
      }
    },
    exportData() {
      this.$refs.export.$el.click()
    }
  }
}
</script>

<style>
  td, th > span {
    white-space: nowrap;
  }
</style>
